import { render, staticRenderFns } from "./CreateAccountPage.vue?vue&type=template&id=3045d7d5&scoped=true&"
import script from "./CreateAccountPage.vue?vue&type=script&lang=js&"
export * from "./CreateAccountPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3045d7d5",
  null
  
)

export default component.exports